<template>
  <transition name="toast-fade">
    <div v-if="visible" class="custom-toast">
      {{ message }}
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Toast',
  data() {
    return {
      visible: false,
      message: '',
      timer: null
    }
  },
  methods: {
    show(message, duration = 2000) {
      // 清除之前的定时器
      if (this.timer) {
        clearTimeout(this.timer)
      }
      
      this.message = message
      this.visible = true
      
      // 设置自动隐藏
      this.timer = setTimeout(() => {
        this.visible = false
        this.timer = null
      }, duration)
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  }
}
</script>

<style scoped>
.custom-toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.85);
  color: white;
  padding: 16px 24px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  z-index: 99999;
  max-width: 80%;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  word-break: break-word;
}

.toast-fade-enter-active {
  animation: toast-in 0.3s ease;
}

.toast-fade-leave-active {
  animation: toast-out 0.3s ease;
}

@keyframes toast-in {
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.9);
  }
  100% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

@keyframes toast-out {
  0% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.9);
  }
}
</style>
